//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _readerSetup from './readerSetup';
export const readerSetup = _readerSetup;
import _reset from './reset';
export const reset = _reset;
export default {readerSetup, reset};

